import { Component, OnInit, ViewChild } from '@angular/core';
import { DataTableDirective } from 'angular-datatables';
import { Subject } from 'rxjs';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { TraerDatosService } from 'src/app/services/traer-datos-service';
import { mensajeSesionExpiradaService } from 'src/app/services/mensajeSesionExpirada.service';
import Swal from 'sweetalert2';
import { HttpHeaders } from '@angular/common/http';

@Component({
  selector: 'app-permisos-modulos',
  templateUrl: './permisos-modulos.component.html',
  styleUrls: ['./permisos-modulos.component.css']
})
export class PermisosModulosComponent implements OnInit {
  datoss=JSON.parse(localStorage.getItem('datos')!);
  mailusu= this.datoss.correop;
  cargos = this.datoss.cargodb;

  @ViewChild(DataTableDirective, {static: false})
  dtElement: DataTableDirective;

  dtOptions: any={};
  dtTrigger= new Subject;

  API_URI = environment.uri_api;
  users:any=[];
  us:any=[];

  checkControlEscolar=true;
  checkProgramExtra=true;
  checkCatalogos=true;
  checkUsuarios=true;
  checkOvh=true;
  checkPreinscripcion=true;
  checkPermisos=true;
  checkAjedrez=true;
  checkDescargas=true;
  checkReapertura=true;
  ControlDG=true;  

  cargo:string;
  idcargo:number;

  datosStorage:any;
  cargoperfil:string;

  constructor(private traer:TraerDatosService,private msj:mensajeSesionExpiradaService,private router:Router) { }

  ngOnInit(): void {
  
    this.traerUsuarios();
    this.permisos();
  }

  traerUsuarios(){

    this.dtOptions = {
      pagingType: 'full_numbers',
      pageLength:10,
      searching:true,
      processing:true,
      language:{
        url:'//cdn.datatables.net/plug-ins/1.12.1/i18n/es-MX.json'
      }
    };

    var t=localStorage.getItem('token');
    const httpHeaders=new HttpHeaders({
      'content-type':'application/json',
      'Authorization': ''+t
    });
  
      this.traer.http.get(this.API_URI+`/getCargos/${this.cargos}`,{headers:httpHeaders}).subscribe( 
      res=>{

        if(res=="TOKEN-EXPIRADO"){
          this.msj.tokenExpiradoCerrarSesion();  
          return; 
      } 

       this.users=res;
       console.log(res)
       this.dtTrigger.next();
      })

  }

  ngOnDestroy(): void {
    this.dtTrigger.unsubscribe();
  }

  openPermisos(idcargo:number){

    var t=localStorage.getItem('token');
    const httpHeaders=new HttpHeaders({
      'content-type':'application/json',
      'Authorization': ''+t
    });

  
    this.traer.http.get(this.API_URI+`/getPermisos/${idcargo}`,{headers:httpHeaders})
    .subscribe((res:any)=>{

      if(res=="TOKEN-EXPIRADO"){
        this.msj.tokenExpiradoCerrarSesion();   
        return;
    } 
  
      console.log(res);
  
    this.us=res;
    this.VerModulos();   
  
    }) 

  }

  VerModulos(){
  
    if(this.us[0].control_escolar==false){
      this.checkControlEscolar=false;
    }else{this.checkControlEscolar=true;}
    if(this.us[0].programas_extra==false){
      this.checkProgramExtra=false;
    }else{this.checkProgramExtra=true;}
    if(this.us[0].catalogos==false){
      this.checkCatalogos=false;
    }else{this.checkCatalogos=true;}
    if(this.us[0].usuarios==false){
      this.checkUsuarios=false;
    }else{this.checkUsuarios=true;}
    if(this.us[0].ovh==false){
      this.checkOvh=false;
    }else{this.checkOvh=true;}
    if(this.us[0].preinscripcion==false){
      this.checkPreinscripcion=false;
    }else{this.checkPreinscripcion=true;}
    if(this.us[0].permisos_modulos==false){
      this.checkPermisos=false;
    }else{this.checkPermisos=true;}
    if(this.us[0].ajedrez==false){
      this.checkAjedrez=false;
    }else{this.checkAjedrez=true;}
    if(this.us[0].descargas==false){
      this.checkDescargas=false;
    }else{this.checkDescargas=true;}
    if(this.us[0].reapertura==false){
      this.checkReapertura=false;
    }else{this.checkReapertura=true;}

  }

  testCheckControlEscolar(event:any){
    console.log(event.target.checked); 
    this.us[0].control_escolar=event.target.checked;
      console.log(this.us);
  }
  testCheckProgramExtra(event:any){
    console.log(event.target.checked);
    this.us[0].programas_extra=event.target.checked;
      console.log(this.us);
  }
  testCheckCatalogos(event:any){
    console.log(event.target.checked);
    this.us[0].catalogos=event.target.checked;
      console.log(this.us);
  }
  testCheckUsuarios(event:any){
    console.log(event.target.checked);
    this.us[0].usuarios=event.target.checked;
      console.log(this.us);
  }
  testCheckOvh(event:any){
    console.log(event.target.checked);
    this.us[0].ovh=event.target.checked;
      console.log(this.us);
  }
  testCheckPreinscripcion(event:any){
    console.log(event.target.checked);
    this.us[0].preinscripcion=event.target.checked;
      console.log(this.us);
  }
  testCheckPermisos(event:any){
    console.log(event.target.checked);
    this.us[0].permisos_modulos=event.target.checked;
      console.log(this.us);
  }
  testCheckAjedrez(event:any){
    console.log(event.target.checked);
    this.us[0].ajedrez=event.target.checked;
      console.log(this.us);
  }
  testCheckDescargas(event:any){
    console.log(event.target.checked);
    this.us[0].descargas=event.target.checked;
      console.log(this.us);
  }
  testCheckReapertura(event:any){
    console.log(event.target.checked);
    this.us[0].reapertura=event.target.checked;
      console.log(this.us);
  }

  savePermisos(){

     var t=localStorage.getItem('token');
    const httpHeaders=new HttpHeaders({
      'content-type':'application/json',
      'Authorization': ''+t
    });

    console.log(this.us[0])
    this.traer.http.post(this.API_URI+`/savePermisos/${this.us[0].idcargo}/${this.mailusu}`,this.us[0],{headers:httpHeaders})
    .subscribe((res:any)=>{



      if(res=="Actualizados"){
        Swal.fire({
          position: 'top-end',
          icon: 'success',
          title: 'Permisos Actualizados',
          showConfirmButton: false,
          timer: 1500
        }
        )
        setTimeout(function () { location.reload(); }, 2000);
      } else {
        console.log("Error al actualizar");
      }
    
        console.log(res);
    
      })
  }

  datos(cargo:string,idcargo:number){

    this.cargo=cargo;
    this.idcargo=idcargo;
    console.log(this.idcargo);

    this.openPermisos(this.idcargo);

  }

    permisos(){

 
  if (this.cargos=="Control Escolar Direccion Academica"){ 
    this.ControlDG=false;


   } 

   
  }

}
